import {  useContext, useEffect, useReducer, useState } from "react"
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext"
import { Contexto } from "../Context/Contexto"
import { MensajeCont } from "../Context/MensajeContext"
import { Mostrar } from "../Context/Mostrando"
import { NotificacionesGeneral } from "../Context/Notificaciones_Context"
import { tokens } from "../Context/Tokens"
import { Recepcion } from "../Model/Recepcion"
import CuentaNew from "../Paginas/CuentaNew"
import { Get } from "../Rutas/ApiRest"
import { AmigoReferid, Carga } from "../Rutas/Servicios"
import { ReferenciaDTO } from "../Model/ReferenciaDTO";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { Cookies, useCookies } from 'react-cookie'


function Inicio(){
  const [clase,setClase]=useState<number>(0)
  const [Casillas,SetCasillas]=useState<any[]>([])
  const [cookies,removeCookie] = useCookies(['rutcli','mensaje'])
  const [state,dispatch]=useReducer(reducer,{nombre:""})
  const {SetLoading,SetBusquedaShow,SetMensajeEmergente,Redireccion,SetRedireccion}=useContext(MensajeContActualizacion)
  const [ResultadoBusqueda,SetResuktadoBusqueda]=useState<Recepcion>()
  const clas="toggle-sidebar"
  const {toggleTodo}=useContext(tokens)
  const [Empresa,SetEmpresa]=useState<boolean>(false)
  const {tok}=useContext(tokens)
  const {ActualizarCasilla}=useContext(Contexto)
  const {cierreSession}=useContext(Contexto)
  const {ActualizacionGuia}=useContext(GuiaBusquedaCont)
  const {Cli}=useContext(Contexto)
  const {NotifiContext}=useContext(NotificacionesGeneral)
  const {ActualizarNotificacion}=useContext(NotificacionesGeneral)
  const {Actualizar,Mostrardo}=useContext(Mostrar)
  const {ActualizacionMensaje}=useContext(MensajeCont)
  const Busqueda="search-bar"
  const BusquedaDesplegada="search-bar search-bar-show"
  const [BusquedaActivo,setBusquedaActivo]=useState<boolean>(false)
  

  
    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":return{nombre:""}
      }
    
      return state;
    }

    function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      
    }

    const BusquedaLlamado=()=>
    {
      if(state.nombre!="")
      {
        toggleTodo();
        const datos=Get(Carga.Busqueda.replace("@rut",Cli.rut+"").replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@guia",state.nombre+""),"application/json",tok)
        datos?.then(resultado=>SetResuktadoBusqueda(resultado))
      }else
      {
        SetLoading(false);
        ActualizacionMensaje("Ingrese Guia a buscar");
        SetMensajeEmergente("Ingrese Guia a buscar");
      }
      
      
    }
    useEffect(()=>{
      toggleTodo()
      if(ResultadoBusqueda?.casilla!=Cli.lCasilla[Cli.Eleccion].ecode)
      {
        Cli.lCasilla.map((e:any)=>{
          if(e.ecode===ResultadoBusqueda?.casilla)
          {
            ActualizarCasilla(e.Contenido.id);
          }
        })
      }
      if(ResultadoBusqueda?.ubicacion!="")
      {
        switch(ResultadoBusqueda?.ubicacion)
        {
          case "Rastreo":ActualizacionGuia(state.nombre);
                        SetBusquedaShow("Rastreo")
                        Actualizar(ReferenciaDTO.UbicacionCarga);
                        window.location.href="#RastreoBusqueda"
                  break;
          case "Pago Pendiente":ActualizacionGuia(state.nombre);
                        Actualizar(ReferenciaDTO.UbicacionPagoPendiente);
                        window.location.href="#pagohistorial"
                  break;
          case "Historial":ActualizacionGuia(state.nombre);
                           SetBusquedaShow("Historial")  
                           Actualizar(ReferenciaDTO.UbicacionHistorial);
                           window.location.href="#historial";  
                  break;    
          case "Prepago": ActualizacionGuia(state.nombre);    
                        Actualizar(ReferenciaDTO.UbicacionPrepago);
                        window.location.href="#prepago";
                  break;
                  case "Factura": ActualizacionGuia(state.nombre);    
                        Actualizar(ReferenciaDTO.UbicacionSinFactura);
                        window.location.href="#Factura";
                  break;
        }
        ActualizacionMensaje("");
      }
      else
      {
        ActualizacionMensaje(ResultadoBusqueda.mensaje)
        SetMensajeEmergente(ResultadoBusqueda.mensaje)
        ActualizacionGuia("-1")
        window.location.href="#"
      }
      SetLoading(false);
    },[ResultadoBusqueda])
  

    const CargarCasillas=()=>
    {
        if(Casillas.length==0)
        {
            Cli.lCasilla.map((e:any)=>
                {
                    if(e.ecode!="")
                    {
                      SetCasillas((a)=>[...a, <li key={e.Contenido.id}> <a href="#preferencia" onClick={()=>{ActualizarCasilla(e.Contenido.id);Actualizar(ReferenciaDTO.UbicacionPreferencia)}} style={{textDecoration:"none"}}> <i className="bi bi-mailbox"></i>{e.ecode} </a> </li> ])
                    }
                }

            )
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
              toggleTodo();
              const dato2=Get(Carga.Notificaciones.replace("@rut",Cli.rut+"").replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
              dato2?.then(resultado=>ActualizarNotificacion(resultado))
            }
        }
    }
    useEffect(()=>{
      const datos=Get(AmigoReferid.ValidacionEmpresa.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode) ,"application/json",tok)
        datos?.then(resultado=>{SetEmpresa(resultado)})
      CargarCasillas();
      SetLoading(false)
    },[])

    const key=(e:any)=>
    {
      if (e.key === 'Enter') {
        BusquedaLlamado();
      }
    }
    useEffect(()=>{
      if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
              toggleTodo();
              const dato2=Get(Carga.Notificaciones.replace("@rut",Cli.rut+"").replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
              dato2?.then(resultado=>{ActualizarNotificacion(resultado)})
            } 
    },[Cli.Eleccion])
    

    const cambiador=()=>
    {
        if(clase==0)
        {
            setClase(1)
        }else
        {
            setClase(0)
        }
    }
    return (
     <>
     <div className={clase==0?"":clas} >
            <header id="header" className="header fixed-top d-flex align-items-center" style={{background:"transparent linear-gradient(to bottom, #FA9700 0%, #FCB201 100%) repeat scroll 0% 0%"}} >
  <div className="d-flex align-items-center justify-content-between"> <a className="logo d-flex align-items-center mx-auto" style={{cursor:"pointer"}} onClick={()=>{SetRedireccion(true)}}> <img src="assets/img/eshopex.png" alt="eShopex"/></a> <a ><i className="bi bi-list toggle-sidebar-btn"  onClick={()=>cambiador()} style={{cursor:"pointer"}}></i></a> </div>
  
  <div className={BusquedaActivo?BusquedaDesplegada:Busqueda}>
    <div className="search-form d-flex align-items-center" >
      <input type="text" value={state.nombre} onChange={cambio} onKeyDown={key} name="nombre" placeholder="Ingresa el número de guia.." title="buscar"/>
      <button type="submit" title="Search" onClick={()=>{SetLoading(true);Actualizar(ReferenciaDTO.UbicacionPreferencia);BusquedaLlamado();setBusquedaActivo(false)}}><i className="bi bi-search"></i></button>
    </div>
  </div>
  <nav className="header-nav ms-auto" >
    <ul className="d-flex align-items-center">
      <li className="nav-item d-block d-lg-none" > <a className="nav-link nav-icon search-bar-toggle " > <i className="bi bi-search"  onClick={()=>setBusquedaActivo(!BusquedaActivo)} ></i> </a> </li>

      
      <li className="nav-item dropdown"> <a className="nav-link nav-icon" data-bs-toggle="dropdown" style={{cursor:"pointer"}}> <i className="bi bi-bell"></i> <span className="badge bg-primary badge-number">{NotifiContext[3].cantidad>0?NotifiContext[3].cantidad:null}</span> </a>
        
        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
          <li className="dropdown-header"> {NotifiContext[3].cantidad>0?"Tiene "+NotifiContext[3].cantidad+" Notificacion":"Sin Notificaciones Pendientes"} <a ><span className="badge rounded-pill bg-primary p-2 ms-2">Todas</span></a></li> 
          <li>
            <hr className="dropdown-divider"/>
          </li>
          {NotifiContext[4].cantidad>0?<li className="notification-item" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionSinFactura);window.location.href="#Factura"}}> <i className="bi bi-file-earmark-x-fill text-danger" ></i>
            <h4>{NotifiContext[4].cantidad} Carga retenida (sin factura)</h4>
          </li>:null}
          <li>
            <hr className="dropdown-divider"/>
          </li>
          {NotifiContext[0].cantidad>0?<li className="notification-item" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionPrepago);window.location.href="#prepago"}}> <i className="bi bi-check-circle-fill text-success" ></i>
            <div>
              <h4>{NotifiContext[0].cantidad} Carga lista para retiro</h4>
              
            </div>
          </li>:null}
          <li>
            <hr className="dropdown-divider"/>
          </li>
          {NotifiContext[1].cantidad>0?<li className="notification-item"  onClick={()=>{Actualizar(ReferenciaDTO.UbicacionPagoPendiente);window.location.href="#pago"}}> <i className="bi bi-exclamation-circle-fill text-warning"></i>
            <div>
              {NotifiContext[1].cantidad==1?<h4>{NotifiContext[1].cantidad} Carga pendiente de pago </h4>:<h4>{NotifiContext[1].cantidad} Cargas pendientes de pagos </h4>} 
              
            </div>
          </li>:null}

        </ul>
        
      </li>
     
      <li className="nav-item dropdown pe-3"> <a className="nav-link nav-profile d-flex align-items-center pe-0" data-bs-toggle="dropdown" style={{cursor:"pointer"}}> <img src="assets/img/profile.png" alt="Profile" className="rounded-circle"/> <span className="d-none d-md-block dropdown-toggle ps-2">Hola {Cli.nombre}</span> </a>
        
        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li> <a className="dropdown-item d-flex align-items-center" style={{cursor:"pointer"}} onClick={()=>{Actualizar(ReferenciaDTO.UbicacionPreferencia)}}>  <i className="bi bi-person"></i> <span>Mi Cuenta</span> </a> </li>
          <li>
            <hr className="dropdown-divider"/>
          </li>
          <li> <a className="dropdown-item d-flex align-items-center" href="#actualizar"  onClick={()=>Actualizar(ReferenciaDTO.UbicacionActualizar)}> <i className="bi bi-gear" ></i> <span>Actualización Información</span> </a> </li>
          <li>
            <hr className="dropdown-divider"/>
          </li>
          <li> <a className="dropdown-item d-flex align-items-center" href="#Entrega"  onClick={()=>{Actualizar(ReferenciaDTO.UbicacionEntrega)}}> <i className="bi bi-truck"></i> <span>Preferencias de entrega</span> </a> </li>
          <li>
            <hr className="dropdown-divider"/>
          </li>
          <li> <a className="dropdown-item d-flex align-items-center" href="#" onClick={()=>{removeCookie("rutcli",Cookies);localStorage.clear();Actualizar(0);cierreSession()}}> <i className="bi bi-box-arrow-right"></i> <span>Salir</span> </a> </li>
        </ul>
      </li>

      
    </ul>
  </nav>

  
</header>
<aside id="sidebar" className="sidebar">
  <ul className="sidebar-nav" id="sidebar-nav">
    <li className="nav-heading"><img src="assets/img/profile.png" alt="" className="rounded-circle img-fluid pb-2" style={{maxWidth:"48px"}}/>
      <p><span>{Empresa?<>{Cli.nombre+" "+Cli.apellidoPaterno}</>:Cli.nombre}</span><br/>
      {Cli?.lCasilla[Cli.Eleccion].ecode}<br/>
      {Empresa?<>Tienes {Cli?.lCasilla[Cli.Eleccion].Contenido.puntosRewards[0]==undefined?0:Cli.lCasilla[Cli.Eleccion].Contenido.puntosRewards[0].cantidadPuntos} Puntos Rewards</>:null} </p>
    </li>
    <li className="nav-item"> <a className="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" style={{cursor:"pointer"}}> <i className="bi bi-person"></i>Mi Cuenta<i className="bi bi-chevron-down ms-auto"></i> </a>
      <ul id="components-nav" className="nav-content collapse" data-bs-parent="#sidebar-nav">
        <li> <a onClick={()=>Actualizar(ReferenciaDTO.UbicacionActualizar)} href="#actualizar" style={{textDecoration:"none"}}> <i className="bi bi-gear"></i>Actualizar Información </a> </li>
        <li> <a onClick={()=>Actualizar(ReferenciaDTO.UbicacionEntrega)} href="#Entrega" style={{textDecoration:"none"}}> <i className="bi bi-truck"></i>Preferencias de Entrega </a> </li>
      </ul>
    </li>
    <li className="nav-item"> <a className="nav-link collapsed" data-bs-target="#components-nav1" data-bs-toggle="collapse" style={{cursor:"pointer"}}> <i className="bi bi-mailbox"></i>{Cli.lCasilla.length==1?"Casilla":"Casillas"}<i className="bi bi-chevron-down ms-auto"></i> </a>
        <ul id="components-nav1" className="nav-content collapse" data-bs-parent="#sidebar-nav">
            {Casillas}
        </ul>
    </li>
    {Empresa?<><li className="nav-item"> <a className="nav-link collapsed" data-bs-target="#components-nav2" data-bs-toggle="collapse" style={{cursor:"pointer"}}> <i className="bi bi-coin"></i>Mis Puntos Rewards<i className="bi bi-chevron-down ms-auto"></i> </a>
      <ul id="components-nav2" className="nav-content collapse" data-bs-parent="#sidebar-nav">
        <li className="nav-item"> <a onClick={()=>{
          if(Mostrardo!=ReferenciaDTO.UbicacionHistorialPuntos)
            {
              
              Actualizar(ReferenciaDTO.UbicacionHistorialPuntos)
            }
          
          }} href="#" style={{textDecoration:"none"}}> <i className="bi bi-clock"></i>Historial Puntos </a> </li>
        <li className="nav-item"> 
          <a onClick={()=>{
            if(Mostrardo!=ReferenciaDTO.UbicacionAmigoReferido)
              {
                
                Actualizar(ReferenciaDTO.UbicacionAmigoReferido);
              }
            }} href="#" style={{textDecoration:"none"}}> <i className="bi bi-person-plus"></i>Historial Amigo referido </a> </li>
        <li className="nav-item"> <a href="#Amigo" style={{textDecoration:"none"}}> <i className="bi bi-star"></i> Refiere un Amigo y gana</a> </li>
        <li className="nav-item"> <a href="https://eshopex.cl/puntos-rewards/" target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}> <i className="bi bi-cash"></i> Programa Puntos Rewards </a> </li>
      </ul>
    </li></>:null}
    
    <li className="nav-item"> <a className="nav-link collapsed" href="#calculadora"  onClick={()=>Actualizar(ReferenciaDTO.UbicacionCalculadora)}> <i className="bi bi-calculator" ></i> Calculadora </a> </li>
    <li className="nav-item"> <a className="nav-link collapsed" href="#prealerta"  onClick={()=>Actualizar(ReferenciaDTO.UbicacionPreAlerta)}> <i className="bi bi-exclamation-triangle" ></i> Ingreso Prealerta </a> </li>
    <li className="nav-item"> <a className="nav-link collapsed" href="#rastreo" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionCarga);SetBusquedaShow("Rastreo")}}> <i className="bi bi-search"></i> Rastreo de Carga </a> </li>
    <li className="nav-item"> <a className="nav-link collapsed" href="#rastreo" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionHistorial);SetBusquedaShow("Historial")}}> <i className="bi bi-clock-history"></i> Historial de Carga </a> </li>
    <li className="nav-item"> <a className="nav-link collapsed" href="#pago" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionPagoPendiente)}}> <i className="bi bi-credit-card"></i> Carga Pendiente de Pago </a> </li>
    {NotifiContext[6]!=undefined?NotifiContext[6].cantidad>0?<><li className="nav-item"> <a className="nav-link collapsed" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionVendemosContigo)}}> <i className="bi bi-bag-check"></i> PreAlertas Vendemos Contigo </a> </li></>:null:null} 
    <li className="nav-item"> <a className="nav-link collapsed" href="#" onClick={()=>{removeCookie("rutcli",Cookies);localStorage.clear();Actualizar(ReferenciaDTO.UbicacionPreferencia);cierreSession()}}> <i className="bi bi-box-arrow-right"></i> Salir </a> </li>
  </ul>
</aside>
<main id="main" className="main"> 
  <CuentaNew></CuentaNew>
</main>
</div>
</>    
    )
}

export default Inicio